export default function DateTimeInput(props){

    return(
        <div className="input-block-admin">
            <label>{props.label}: </label>
            <input id={props.id} type="date" onKeyDown={props.onKeyDown} name={props.name} value={props.value} onChange={props.inputChanged}/>
        </div>
    )
}